<div class="page">
	<div class="player-wrapper">
		@if (playbackUrl()) {
			<div class="aspect-ratio-container">
				<vb-lxp-video-player #player></vb-lxp-video-player>
			</div>

			<div class="stream-badge">
				<div class="stream-badge-dot"></div>
				@if (carNumber()) {
					<span class="stream-badge-text"># {{ carNumber() }}</span>
				}
				@if (driverName()) {
					<span class="stream-badge-text">{{ driverName() }}</span>
				}
				@if (streamTitle() && streamTitle() !== 'Stream') {
					<span class="stream-badge-text">{{ streamTitle() }}</span>
				}
			</div>
		} @else {
			<div class="popout-error">Missing playbackUrl query parameter.</div>
		}
	</div>
</div>
